import axios from 'axios';

export default axios.create({
  baseURL: 'https://apiconcursos.cieemg.org.br',
});
